import React from 'react';
import SEO from '../seo/SEO';
import Hero from '../layout/Hero';
import About from '../layout/About';
import Testimonials from '../layout/Testimonials';
import FAQ from '../layout/FAQ';
import Contact from '../layout/Contact';
import WhatWeDo from '../layout/WhatWeDo';
import Vision2035 from '../layout/Vision2035';
import ImpactJoin from '../layout/ImpactJoin';
import EventsSection from '../events/EventsSection';

function LandingPage() {
  const seoData = {
    title: "Intellectual Oasis Fellowship – Shaping the Future of Education Research in West Africa",
    description: "A nonprofit building a research hub for education in Nigeria and West Africa through a fellowship of scholars, open data publishing, scholarships, and EdTech tools.",
    keywords: "education research West Africa, Nigeria education policy, education data repository, scholarships Nigeria, EdTech tools, research fellowship",
    image: "/images/og-image.jpg"
  };

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "EducationalOrganization",
    "name": "Intellectual Oasis Fellowship",
    "description": seoData.description,
    "url": "https://iofellowship.org",
    "logo": "https://iofellowship.org/logo.png",
    "sameAs": [
      "https://www.facebook.com/people/Intellectual-Oasis-Fellowship/61561270017439/",
      "https://www.instagram.com/io_fellowship/",
      "https://www.linkedin.com/company/intellectual-oasis-fellowship"
    ],
    "offers": {
      "@type": "Offer",
      "category": "Educational Scholarship",
      "description": "Scholarship program supporting students in their educational journey",
      "numberOfItems": "300+"
    },
    "foundingDate": "2020",
    "numberOfEmployees": {
      "@type": "QuantitativeValue",
      "value": "300+",
      "unitText": "Students Supported"
    }
  };

  return (
    <>
      <SEO {...seoData} />
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
      <div className="max-w-[100vw] overflow-x-hidden">
        <main className="relative">
          <Hero />
          <article className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            {/* About Us */}
            <About />
            {/* What We Do */}
            <WhatWeDo />
            {/* 2035 Vision */}
            <Vision2035 />
            {/* Events */}
            <EventsSection />
            {/* Impact / Join Us */}
            <ImpactJoin />
            {/* Social proof / FAQs / Contact */}
            <Testimonials />
            <FAQ />
            <Contact />
          </article>
        </main>
      </div>
    </>
  );
}

export default LandingPage;